import { TFunction } from '@wyz/types';
import { getHomologationBrandImage } from '@wyz/utils';
import { Fragment } from 'react';
import { Flex, Text, Tooltip } from '../../index';
import HomologationLogo from './homologation-logo';

type Homologation = {
  publicKey: string;
  brand: string;
  image: boolean;
};

type Props = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  t: TFunction<any>;
  ean: string;
  homologations?: Homologation[];
  prodInfo?: string;
  imageBaseUrl: string;
};

const HomologationDisplay = ({
  t,
  ean,
  homologations = [],
  prodInfo,
  imageBaseUrl,
}: Props) => {
  if (homologations.length === 0) {
    return null;
  }

  const homologationImageBrand = getHomologationBrandImage(homologations);
  const hover = homologationImageBrand ? (
    <HomologationLogo
      brand={homologationImageBrand}
      imageBaseUrl={imageBaseUrl}
      ean={ean}
      fallback={prodInfo ?? null}
    />
  ) : (
    prodInfo
  );

  return (
    <>
      <hr className='my-2' />
      <Flex
        direction='column'
        alignItems='center'
        className='gap-1'
        id={`product-info-homologation-${ean}`}
      >
        <Text heading='xxs' weight='semi-bold' color='secondary-gray'>
          {t('app.common.product.homologation')}
        </Text>
        {homologations.map(({ publicKey, brand }) => {
          const label = (
            <Text
              weight='bold'
              color='tertiary'
              heading='xxs'
              className={hover ? 'cursor-pointer' : undefined}
            >
              {brand}
            </Text>
          );

          return (
            <Fragment key={publicKey}>
              {hover ? (
                <Tooltip label={hover} className='homologation-tooltip'>
                  {label}
                </Tooltip>
              ) : (
                label
              )}
            </Fragment>
          );
        })}
      </Flex>
    </>
  );
};

export default HomologationDisplay;
